<template>
  <template v-if="visible">
    <div class="feedback">
      <a-form
        ref="formRef"
        :hide-required-mark="true"
        :model="modelForm"
        layout="vertical"
      >
        <a-form-item
          class="form-item-hightlight"
          name="type"
          :rules="[
            { required: true, message: $t('qing-xuan-ze-fan-kui-lei-xing') },
          ]"
        >
          <a-radio-group v-model:value="modelForm.type">
            <a-radio value="0">{{ $t('gong-neng-gu-zhang') }}</a-radio>
            <a-radio value="1">{{ $t('chan-pin-jian-yi') }}</a-radio>
            <a-radio value="2">{{ $t('qi-ta-wen-ti') }}</a-radio>
          </a-radio-group>
        </a-form-item>
        <div class="divide"></div>
        <a-form-item
          class="form-item-hightlight"
          name="description"
          :label="$t('wen-ti-miao-shu')"
          :rules="[
            {
              required: true,
              message: $t('qing-shu-ru-nin-de-wen-ti-huo-jian-yi'),
            },
          ]"
        >
          <div class="question" :data-count="`${textLength} / ${maxLength}`">
            <a-textarea
              v-model:value="modelForm.description"
              :placeholder="$t('qing-shu-ru-nin-de-wen-ti-huo-jian-yi')"
              spellcheck="false"
              :autoSize="{ minRows: 4, maxRows: 6 }"
              @change="handleChange"
            >
            </a-textarea>
          </div>
        </a-form-item>
        <a-form-item
          class="form-item-hightlight"
          name="screenshot"
          :label="$t('shang-chuan-jie-tu-xuan-tian')"
          :rules="[{ required: false, message: $t('qing-shang-chuan-jie-tu') }]"
        >
          <div class="mb-[16px] text-12 text-font-40">
            <span class="text-error-6">*</span>
            <span>{{ $t('jin-zhi-chi-shang-chuan-3m-nei-de-tu-pian') }}</span>
          </div>
          <div class="list" :data-count="dataCount">
            <template v-if="modelForm.fileList?.length">
              <div
                v-for="item of modelForm.fileList"
                :key="item?.uid"
                class="list-item"
              >
                <Resource
                  v-if="item?.status === 'done'"
                  :src="item?.url"
                  :transform-resource="transformImage"
                  alt=""
                  class="w-full h-full object-contain"
                />
                <div
                  v-else
                  class="w-full h-full flex justify-center items-center"
                >
                  <iconpark-icon
                    v-if="item?.status === 'error'"
                    name="circle-close"
                    size="30"
                    fill="#FF5656"
                  ></iconpark-icon>
                  <iconpark-icon
                    v-else-if="item?.status === 'uploading'"
                    name="loading"
                    size="30"
                    class="animate-spin"
                  ></iconpark-icon>
                </div>
                <div v-if="item?.status === 'done'" class="action">
                  <div class="action-option">
                    <a-popover>
                      <template #content>
                        <div class="w-[314px] h-[314px] p-[8px]">
                          <Resource
                            :src="item?.url"
                            :transform-resource="transformImage"
                            alt=""
                            class="w-full h-full rounded-[8px] object-contain"
                          />
                        </div>
                      </template>
                      <EyeOutlined :title="$t('yu-lan')" />
                    </a-popover>
                    <DeleteOutlined
                      :title="$t('shan-chu-wen-jian')"
                      @click="handleDelete(item)"
                    />
                  </div>
                </div>
              </div>
            </template>
            <a-upload
              v-if="modelForm.fileList?.length < 4"
              class="list-item add"
              name="files"
              :max-count="4"
              accept=".jpg,.png,.jpeg,.gif"
              :beforeUpload="beforeUpload"
              :showUploadList="false"
              :custom-request="handleUpload"
              @preview="handlePreview"
              @change="handleUploadChange"
            >
              <div class="list-item add text-primary">
                <iconpark-icon name="plus" size="36"></iconpark-icon>
              </div>
            </a-upload>
          </div>
        </a-form-item>
        <a-form-item
          class="form-item-hightlight"
          name="phone"
          :label="$t('lian-xi-fang-shi-xuan-tian')"
          :rules="[{ required: false, validator: validate }]"
        >
          <a-input
            v-model:value="modelForm.phone"
            :placeholder="
              $t('qing-liu-xia-nin-de-lian-xi-fang-shi-yi-bian-fan-kui-jie-guo')
            "
            class="w-[260px]"
            :maxlength="64"
          ></a-input>
        </a-form-item>
      </a-form>
    </div>
    <div class="mt-[60px]" style="border-top: 1px solid #eceff2"></div>
    <div class="flex justify-center items-center py-[16px]">
      <a-button
        type="primary"
        block
        class="h-[36px] max-w-[390px]"
        :loading="loading"
        @click="handleSave"
      >
        {{ $t('ti-jiao') }}
      </a-button>
    </div>
  </template>
  <div v-else class="result">
    <div class="content">
      <div>
        <iconpark-icon name="circle-success" size="56"></iconpark-icon>
      </div>
      <div
        class="text-[#050512] text-[20px] leading-[28px] font-medium mt-[16px] mb-[30px]"
      >
        {{ $t('gan-xie-nin-de-fan-kui') }}
      </div>
      <div class="w-[128px] h-[128px]">
        <Resource
          class="w-full h-full"
          :src="getFeUrl('/youyan-platform/png/talk-team-qrcode.png')"
          alt="qrcode"
          draggable="false"
        />
      </div>
      <div class="info">
        <span class="block">{{ $t('jia-ru-chan-pin-tan-lun-zu') }}</span>
        <span>{{ $t('zhui-zong-wen-ti-zui-xin-jin-zhan') }}</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { FormInstance } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/es/form'
import { commonUpload, saveFeedback } from '~/api/'
const { $t } = useNuxtApp()
interface FeedbackProps {
  cancel: () => void
}
defineProps<FeedbackProps>()

interface ModelFormProps {
  type: string
  description: string
  phone?: string
  fileList: any[]
}

const formRef = ref<FormInstance>()
const visible = ref<boolean>(true)
const loading = ref<boolean>(false)

const modelForm = reactive<ModelFormProps>({
  type: '',
  description: '',
  phone: '',
  fileList: [],
})

const dataCount = computed(() => `${modelForm.fileList.length}/4`)

const maxLength = 300

const getStringLength = (str: string): number => {
  let len = 0
  const chineseRegex = /[\u4E00-\u9FA5]/g
  const chinese = str?.match(chineseRegex)
  if (chinese) {
    len += chinese.length * 2
  }

  return str?.length - (chinese?.length ?? 0) + len
}

const textLength = computed(() => {
  const len = getStringLength(modelForm.description)
  return len > maxLength ? maxLength : len
})

const sliceText = (text: string) => {
  let length = 0
  let result = ''
  for (let i = 0; i < text.length; i++) {
    const char = text[i]
    const tempLen = getStringLength(char)
    if (length + tempLen <= maxLength) {
      result += char
      length += tempLen
    } else {
      break
    }
  }
  return result
}

const handleChange = (e: any) => {
  const text = e.target?.value
  modelForm.description = sliceText(text)
}

const validate = (_rule: Rule, value: string) => {
  const emailReg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  const telReg = /^(?:(?:\d{3}-)?\d{8}|^(?:\d{4}-)?\d{7,8})(?:-\d+)?$/
  const mobReg =
    /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
  if (value) {
    const isOk =
      mobReg.test(value) || emailReg.test(value) || telReg.test(value)
    if (!isOk) {
      return Promise.reject(
        new Error($t('qing-shu-ru-zheng-que-de-lian-xi-fang-shi'))
      )
    }
  }
  return Promise.resolve()
}

const beforeUpload = (file: any) => {
  const isFileMatch = [
    'image/jpeg',
    'image/png',
    'image/jpg',
    'image/gif',
  ].includes(file.type)
  if (!isFileMatch) {
    message.error($t('wen-jian-lei-xing-bu-zheng-que'))
  }

  const isMatchSize = file.size / 1024 / 1024 < 3
  if (!isMatchSize) {
    message.error($t('tu-pian-zui-da-wei-3mb'))
  }

  return isFileMatch && isMatchSize
}

const handleDelete = (file: any) => {
  modelForm.fileList = modelForm.fileList.filter(
    (item: any) => item?.uid !== file?.uid
  )
}

const handlePreview = (file: any) => {}

const handleUploadChange = (info: any) => {
  if (info.file.status === 'uploading') {
    modelForm.fileList.push({ uid: info?.file?.uid, status: 'uploading' })
  }
}

const handleUpload = async (values: any) => {
  const index = modelForm.fileList.findIndex(
    (item: any) => item.uid === values?.file?.uid
  )
  try {
    const formData = new FormData()
    formData.append('file', values?.file)
    const response: any = await commonUpload(formData)
    if (response?.error_code === 0) {
      if (index !== -1) {
        modelForm.fileList[index].status = 'done'
        modelForm.fileList[index].url = response?.data?.url
      }
    }
  } catch (error) {
    console.error(error)

    modelForm.fileList[index].status = 'error'
  }
}

const handleSave = async () => {
  const route = useRoute()
  loading.value = true
  try {
    await formRef.value?.validate()
    const response: any = await saveFeedback({
      feedback_type: modelForm.type,
      feedback_source: route?.query?.feedback ? 1 : 0, // 编辑器1 服务平台0
      description: modelForm.description,
      screenshot_urls: modelForm.fileList.map((item: any) => item.url),
      content_information: modelForm.phone,
    })
    if (response?.error_code === 0) {
      visible.value = false
      loading.value = false
    }
  } catch (error) {
    console.error(error)

    loading.value = false
  }
}
</script>
<style lang="scss" scoped>
.feedback {
  @apply px-[80px] pt-[24px];

  .form-item-label {
    :deep(.ant-form-item-label > label) {
      color: inherit;
    }
  }

  .form-item-hightlight {
    :deep(.ant-form-item-label > label) {
      @apply text-font-1 text-14;

      &::before {
        display: none;
      }
    }
  }

  :deep(textarea.ant-input) {
    padding-bottom: 16px;
  }

  :deep(.ant-radio-group) {
    @apply flex flex-nowrap gap-x-[16px];
  }

  :deep(.ant-radio-wrapper) {
    @apply bg-back-2 rounded-[8px] py-[13px] pl-[16px] pr-[50px];
    margin-inline: 0;
  }

  .divide {
    @apply bg-back-4 rounded-[8px] h-[1px] mb-[24px];
  }

  :deep(.ant-upload-select) {
    background-color: #f6f8f9 !important;
  }

  .question {
    @apply relative;
    &::after {
      @apply absolute right-[8px] bottom-[2px] text-[12px] text-font-40 font-normal;
      content: attr(data-count);
    }
  }

  .list {
    @apply flex flex-wrap gap-[12px];

    &::after {
      @apply text-12 text-font-30 inline-flex items-end;
      content: attr(data-count);
    }

    .list-item {
      @apply relative w-[90px] h-[90px] bg-back-4 rounded-[8px] transition-all overflow-hidden;

      &.add {
        @apply bg-back-2 flex justify-center items-center text-primary hover:border-primary cursor-pointer;
        border: 1px dashed transparent;
      }

      img {
        @apply w-full h-full;
      }

      .action {
        @apply w-full h-full absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex justify-center items-center rounded-[8px] transition-colors;

        .action-option {
          @apply relative text-white flex flex-nowrap gap-x-[8px] text-[16px] opacity-0 transition-all;
        }

        &:hover {
          background-color: var(--text-1-50);
          .action-option {
            opacity: 1;
          }
        }
      }
    }
  }
}

.result {
  @apply w-full h-[638px] flex justify-center items-center pt-[20px];

  .content {
    @apply text-center;

    .info {
      @apply mt-[5px] text-12 text-font-70;
    }
  }
}
</style>
